import React, { useEffect, useState } from 'react'
import Input from 'react-phone-number-input/input';

import logo from '../../assets/images/logo.png';
import burgerIcon from '../../assets/images/burger-icon.svg';
import closeIcon from '../../assets/images/close-icon.svg';
import screen7gameimg from '../../assets/images/screen7gameimg.png';
import playbutton from '../../assets/images/playbutton.svg';
import football from '../../assets/images/football.svg';
import dallaslogo from '../../assets/images/dallaslogo.svg';
import dollar from '../../assets/images/dollar.svg';
import message from '../../assets/images/message.svg';
import lock from '../../assets/images/lock.svg';
import phone from '../../assets/images/phone.svg';
import username from '../../assets/images/username.svg';
import hide from '../../assets/images/hide.svg';
import promoIcon from '../../assets/images/promo_icon.png';

import './index.css';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { registerAct, playDemoAct } from '../../store/actions/authActions';
import Template from '../Game/Template';
import VideoModal from '../../components/videoModal/index.js';
import sampleVideo from '../../assets/video/BallhogIntro.mp4';

const HelpComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token, loading, error } = useSelector((state) => state.auth);

    const [formData, setFormData] = useState({})
    const [validEmail, setValidEmail] = useState(false);
    const [validName, setValidName] = useState(false);
    const [validPhoneNumber, setValidPhoneNumber] = useState(false);

    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    // Redirect to the index route after successful login
    useEffect(() => {
        dispatch(playDemoAct(false));
        if (token) {
            navigate('/'); // Redirect to the index route or desired page
        }
    }, [token, navigate]);

    const handleChange = (e, prop) => {
        let inputData = { ...formData }
        inputData[prop] = e && e.target ? e.target.value : e;
        setFormData(inputData);
    }

    const handleSubmit = (e) => {
        console.log((!formData['phoneNumber'] || formData['phoneNumber'] === undefined),formData['phoneNumber'],'phoneNumber')
        if (!formData['name'] || formData['name'] === undefined) {
            setValidName(true)
        } else if (!formData['email'] || formData['email'] === undefined) {
            setValidEmail(true)
        } else if (!formData['phoneNumber'] || formData['phoneNumber'] === undefined) {
            setValidPhoneNumber(true)
        } else {
            e.preventDefault();
            dispatch(registerAct(formData));
            // navigate('/');
        }
    };

    const handlePlayDemo = (e) => {
        e.preventDefault();
        dispatch(playDemoAct(true));
        navigate('/');
    }

    // const showVideo = () => {
    //     // console.log('show video')
    //     setVideoModal(true);
    // }

    console.log(formData,'formData')
    console.log(validName, validEmail, validPhoneNumber, 'valid values')
    return (
        <>
            <div className='screen-7-section'>
                <div className='screen-7-content'>
                    <div className='screen-gameimgpart'>
                        <div className='screen-gameimage'>
                            <img src={screen7gameimg} alt="gameimg" className='img-fluid' />
                        </div>
                        <div className='screen-logo-part'>
                            <div className='screen-logo-image'>
                                <Link to="/landing">
                                    <img src={logo} alt="logo" className='img-fluid' />
                                </Link>
                            </div>
                            <div className='screen-7-title'>
                                <h3>What is BallHog</h3>
                            </div>
                            <div className='demo-game-button'>
                                {/* <img src={playbutton} alt="play" className='img-fluid' onClick={openModal} /> */}
                                <a onClick={openModal}>Watch AI demo video</a>
                            </div>
                            <div className='demo-game-button'>
                                <a onClick={handlePlayDemo}>Play Demo Game</a>
                            </div>
                        </div>
                    </div>
                    <div className='screen-7-help-part'>
                        <div className='timeline-process'>
                            <div className='timeline-process-info'>
                                <div className='timeline-process-image'>
                                    <img src={football} alt="football" className='img-fluid' />
                                </div>
                                <span className='timeline-process-content'>Choose a Game
                                    <br />to watch</span>
                            </div>
                            <div className='timeline-process-info'>
                                <div className='timeline-process-image'>
                                    <img src={dallaslogo} alt="football" className='img-fluid' />
                                </div>
                                <span className='timeline-process-content'>Choose a Team
                                    <br />to root for</span>
                            </div>
                            <div className='timeline-process-info'>
                                <div className='timeline-process-image'>
                                    <img src={dollar} alt="football" className='img-fluid' />
                                </div>
                                <span className='timeline-process-content'>Watch and Win
                                    <br />It's that easy!</span>
                            </div>
                        </div>
                        <div className='help-info-content text-center'>
                            <p><span>BALLHOG</span><br /> Get ready for something<br /> different</p>
                        </div>
                    </div>
                    <div className='start-playing-part'>
                        <span className='screen-purple-glow-title'>START PLAYING TODAY</span>
                        <div className='start-playing-ballhog'>
                            <p><span>BALLHOG</span> is currently in beta mode. <strong>Sign up</strong> and see what makes <span>BALLHOG</span> different.</p>
                        </div>
                        <div className='screen-form'>
                            {/* <Form>
                                <Form.Group controlId="formGroupText" className='form-group'>
                                    <Form.Control type="text" placeholder="Username" />
                                    <img src={username} alt="message" className='img-fluid' />
                                </Form.Group>
                                <Form.Group controlId="formGroupEmail" className='form-group'>
                                    <PhoneInput className='form-control' placeholder="Phone Number" onChange={e => { }} />
                                    <img src={phone} alt="phone" className='img-fluid' />
                                </Form.Group>
                                <Form.Group controlId="formGroupPassword" className='form-group'>
                                    <Form.Control type="password" placeholder="Password" />
                                    <img src={lock} alt="lock" className='img-fluid' />
                                    <img src={hide} alt="hide" className='img-fluid hide-password' />
                                </Form.Group>
                                <Link to='/landing'>
                                    <Button type="submit" className='sign-in-btn'>Submit</Button>
                                </Link>
                            </Form> */}
                            <Form>
                                <Form.Group controlId="formGroupEmail" className='form-group mb-4'>
                                    <Form.Control
                                        type="text"
                                        placeholder="User Name"
                                        onChange={(e) => handleChange(e, 'name')}
                                        value={formData['name']}
                                    />
                                    <img src={username} alt="username" className='img-fluid' />
                                </Form.Group>
                                {validName && <div className="invalid-feedback d-block mb-1 mx-3">User Name is required</div>}
                                <Form.Group controlId="formGroupEmail" className='form-group'>
                                    <Input
                                        country="US"
                                        international
                                        withCountryCallingCode
                                        className={`form-control ${validEmail ? 'is-invalid' : ''}`}
                                        onChange={(e) => handleChange(e, 'email')}
                                        value={formData['email']}
                                    />
                                    <img src={phone} alt="message" className='img-fluid' />
                                </Form.Group>
                                {validEmail && <div className="invalid-feedback d-block mb-1 mx-3">Phone Number is required</div>}
                                <Form.Group controlId="formGroupEmail" className='form-group'>
                                    <Form.Control
                                        type="text"
                                        className={`form-control ${validEmail ? 'is-invalid' : ''}`}
                                        placeholder="Email"
                                        onChange={(e) => handleChange(e, 'phoneNumber')}
                                        value={formData['phoneNumber']}
                                    />
                                    <img src={message} alt="message" className='img-fluid' />
                                </Form.Group>
                                {validPhoneNumber && <div className="invalid-feedback d-block mb-1 mx-3">Email is required</div>}
                                <Form.Group controlId="formGroupEmail" className='form-group'>
                                    <Form.Control type="text" placeholder="PROMO CODE" onChange={(e) => handleChange(e, 'promoCode')} value={formData['promoCode']} />
                                    <img src={promoIcon} alt="message" className='img-fluid' style={{ width: 18, height: 18 }} />
                                </Form.Group>
                                <Form.Group controlId="formGroupPassword" className='form-group'>
                                    <Form.Control type="password" placeholder="Password" onChange={(e) => handleChange(e, 'password')} value={formData['password']} />
                                    <img src={lock} alt="lock" className='img-fluid' />
                                    <img src={hide} alt="hide" className='hide-password' />
                                </Form.Group>
                                {/* <Form.Group controlId="formGroupPassword" className='form-group'>
                                    <Form.Control type="password" placeholder="Confirm Password" onChange={(e) => handleChange(e, 'confirmPassword')} value={formData['confirmPassword']} />
                                    <img src={lock} alt="lock" className='img-fluid' />
                                    <img src={hide} alt="hide" className='hide-password' />
                                </Form.Group> */}
                                {/* <Link to='/screen2'> */}
                                <Button className='sign-in-btn' onClick={handleSubmit}>SIGN UP</Button>
                                {/* </Link> */}
                            </Form>
                            <div className='sign-up-block'>
                                <p>Have an account? <Link to="/login">Sign in</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <VideoModal
                isOpen={isModalOpen}
                onClose={closeModal}
                videoSrc={sampleVideo}
            />
        </>
    )
}

export default HelpComponent
